module.exports = __webpack_public_path__ + "static/media/16UNODC20.217528b6.jpg";